import { Chip, Divider } from '@mui/material';

export function QuizFormSeparator({
  icon,
  label,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: React.ReactElement<any>;
  label: string;
}) {
  return (
    <Divider sx={{ mt: 4 }}>
      <Chip icon={icon} label={label} />
    </Divider>
  );
}
